import { Stack, Text } from '@backyard-ui/core';

import { RatingStars } from '@/presenters/components/common/RatingStars';

const EmptyFeedback = () => (
  <Stack
    align={{ initial: 'flex-start', sm: 'center' }}
    direction={{ initial: 'column', sm: 'row' }}
  >
    <RatingStars rating={0} />
    <Text color="gray-600">Nenhuma avaliação publicada até o momento.</Text>
  </Stack>
);

export default EmptyFeedback;
